import { themeSupportsDarkMode } from '../selectors/themeSupportsDarkMode';
import { BASE_THEME_ID, BASE_OFFICE_THEME_ID } from './themeConstants';

export function getThemeDataName(themeId: string, isDarkTheme: boolean): string {
    if (isDarkTheme && !themeSupportsDarkMode(themeId)) {
        themeId = BASE_THEME_ID;
    }
    if (!isDarkTheme && (themeId === BASE_THEME_ID || themeId === BASE_OFFICE_THEME_ID)) {
        return `${BASE_THEME_ID}`;
    }
    return `${themeId}${isDarkTheme ? '.dark' : ''}`;
}
